import React from "react";
import AppContext from "../Context/Context";
import axiosAuth from "../Axios/Interceptors";
import { useState, useEffect, useRef } from "react";

import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import DragDrop from "../DragDrop/DragDrop";
import moment from "moment";
import {
  DownloadClientsDataInExcel,
  SanitizeHtml,
  getAccessSettings,
  removeNonNumeric,
} from "../Shared/Utility";
import InputMask from "../App/InputMask";
import { useGlobalState } from "../Context/GlobalStateContext";
import MultiSelectionDropdownV3 from "../App/MultiSelectionDropdownV3";
import Confirmation from "../App/Confirmation";
import ApprovalsScreen from "./ApprovalsScreen";

export default function ReInvestmentData() {
  const globalState = useGlobalState();

  const [gridData, setGridData] = useState<any>([]);

  const [firstAccord, setFirstAccord] = useState(false);
  const [secondAccord, setSecondAccord] = useState(true);

  const [showAnimation, setShowAnimation] = useState(false);
  const [canEdit, setCanEdit] = useState(false);

  const [currentView, setCurrentView] = useState(1);
  const [selectedPIDs, setSelectedPIDs] = useState("");

  const [filterData, setFilterData] = useState({
    ProgramID: globalState.TopFilterData.IBBProgramID,
    QuarterID: globalState.TopFilterData.QuarterID,
    IBBScorecardID: 0,
    PFIDealerID: 0,
    PFIBrandID: 2,
  });

  const [programList, setProgramList] = useState<any>([]);

  const [quarterList, setQuarterList] = useState<any>([]);

  const [importerList, setImporterList] = useState<any>([]);
  const [formData, setFormData] = useState<any>({});
  const [totalData, setTotalData] = useState<any>({});

  const [foreignKeysData, setForeignKeysData] = useState<any>([]);

  useEffect(() => {
    const search = window.location.search;
    const params = new URLSearchParams(search);

    let QuarterID = params.get("qid") as any;
    if (QuarterID && QuarterID != "") QuarterID = Number(QuarterID);
    else QuarterID = filterData.QuarterID;

    let IBBScorecardID = params.get("scid") as any;
    if (IBBScorecardID && IBBScorecardID != "")
      IBBScorecardID = Number(IBBScorecardID);
    else IBBScorecardID = filterData.IBBScorecardID;

    let PFIDealerID = params.get("dlid") as any;
    if (PFIDealerID && PFIDealerID != "") PFIDealerID = Number(PFIDealerID);
    else PFIDealerID = filterData.PFIDealerID;

    let IBBProgramID = params.get("pid") as any;
    if (IBBProgramID && IBBProgramID != "") IBBProgramID = Number(IBBProgramID);
    else IBBProgramID = filterData.ProgramID;

    setFilterData((prevState: any) => ({
      ...prevState,
      ProgramID: IBBProgramID,
      PFIDealerID: PFIDealerID,
      IBBScorecardID: IBBScorecardID,
      QuarterID: QuarterID,
    }));

    IBBProgramGetProgramListForScorecard(
      IBBProgramID,
      QuarterID,
      IBBScorecardID,
      PFIDealerID
    );

    IBBReInvestmentGetCompleteDataSetForForeignKeysCustom();
  }, []);

  useEffect(() => {
    if (filterData.ProgramID > 0) {
      IBBProgramGetScorecardListForScorecard();
    }
  }, [filterData.ProgramID, filterData.QuarterID]);

  useEffect(() => {
    if (programList.length > 0 && filterData.ProgramID > 0) {
      IBBReInvestmentGetCompleteGridDataCustom();
    }
  }, [
    programList,
    filterData.ProgramID,
    filterData.QuarterID,
    filterData.IBBScorecardID,
  ]);

  useEffect(() => {
    assignAvailableAmount();
  }, [formData.IBBReInvestmentID, formData.RequestedAmountInUSD]);

  useEffect(() => {
    if (formData.IBBReInvestmentID > 0) IBBReInvestmentGetDataForApproval();
  }, [formData.IBBReInvestmentID]);

  function IBBProgramGetProgramListForScorecard(
    IBBProgramID: number,
    QuarterID: number,
    IBBScorecardID: number,
    PFIDealerID: number
  ) {
    if (IBBProgramID == 0) IBBProgramID = filterData.ProgramID;
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.ibbprogramid = IBBProgramID;
    object.numericquarter = QuarterID;
    object.pfidealerid = PFIDealerID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/IBBProgramGetProgramListForScorecard",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;
          if (result.length > 1 && result[0].length > 0) {
            setProgramList(result[0]);
            if (IBBProgramID == 0) {
              IBBProgramID = result[0][0].IBBProgramID;
              setFilterData((prevState: any) => ({
                ...prevState,
                ProgramID: IBBProgramID,
              }));
            }

            setImporterList(result[1]);

            setQuarterList(result[2]);
            if (QuarterID == 0) {
              let QuarterID = result[2][0].PID;
              setFilterData((prevState: any) => ({
                ...prevState,
                QuarterID: QuarterID,
              }));
            }
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBProgramGetScorecardListForScorecard() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.ibbprogramid = filterData.ProgramID;
    object.numericquarter = filterData.QuarterID;
    object.pfidealerid = filterData.PFIDealerID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/IBBProgramGetScorecardListForScorecard",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;
          if (result.length > 0) {
            setImporterList(result[0]);

            if (
              result[0].length > 0 &&
              globalState.AppAccessLevelData.DID > 0
            ) {
              let IBBScorecardID = result[0][0].PID;
              setFilterData((prevState: any) => ({
                ...prevState,
                IBBScorecardID: IBBScorecardID,
              }));
            }
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBReInvestmentGetCompleteDataSetForForeignKeysCustom() {
    let object = {} as any;
    object.appid = AppContext.App;
    setShowAnimation(true);
    axiosAuth
      .get(
        AppContext.AppBaseURL +
          "api/IBBReInvestment/IBBReInvestmentGetCompleteDataSetForForeignKeysCustom"
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;
          if (result.length > 0) {
            setForeignKeysData(result);
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBReInvestmentGetCompleteGridDataCustom() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbprogramid = filterData.ProgramID;
    object.quarterid = filterData.QuarterID;
    object.ibbscorecardid = filterData.IBBScorecardID;
    object.recordsperpage = 1000;
    object.isdeleted = false;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBReInvestment/IBBReInvestmentGetCompleteGridDataCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;
          debugger;
          if (result.length > 1) {
            if (result[0].length > 0) setTotalData(result[0][0]);
            setGridData(result);
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  //Dragdrop starts

  const [dragDropFeatures, setDragDropFeatures] = useState({
    ObjectID: 0,
    ObjectType: AppContext.FileUploadObjectTypeReInvestmentFile,
    MaxAllowedFiles: 10,
    UploadType: 3,
    FolderName: "IBB-ReInvestment-Data",
    PTUploadedFiles: [],
  });

  const [uploadFileList, setUploadFileList] = useState<any>([]);
  const [triggerChild, setTriggerChild] = useState(false);
  const [showDragdrop, setShowDragdrop] = useState(true);

  function handleDragDropCallback(ChildData: any) {
    setUploadFileList(ChildData);
  }

  function showPopUpForSaveFiles(ObjectType: number, ObjectID: number) {
    if (formData.RequestedAmountInUSD <= formData.AvailableAmountInUSD) {
      if (uploadFileList && uploadFileList.length > 0)
        SaveFiles(ObjectType, ObjectID);
      else IBBReInvestmentSaveCustom([]);
    } else
      AppContext.ShowNotification(
        "error",
        "You can not use more than the available budget."
      );
  }

  function SaveFiles(ObjectType: number, ObjectID: number) {
    let uploadFileListArray = [];
    for (let index = 0; index < uploadFileList.length; index++) {
      if (!uploadFileList[index].AlreadyUploaded) {
        uploadFileListArray.push(uploadFileList[index]);
      }
    }

    if (uploadFileListArray && uploadFileListArray.length > 0) {
      setShowAnimation(true);
      let object = {} as any;
      object.typeid = -1;
      object.objecttype = ObjectType;
      object.objectid = ObjectID;
      object.applicationid = AppContext.App;
      object.filesdata = uploadFileListArray;
      axiosAuth
        .post(
          AppContext.FileManegmentAPI + "api/PTAttachment/SaveFilesData",
          object
        )
        .then((response) => {
          if (response.data.Status === 1) {
            setTriggerChild(!triggerChild);
            let l_response = response.data.Data;
            IBBReInvestmentSaveCustom(l_response);
          } else {
            AppContext.ShowNotification("error", response.data.Message);
          }
          //setShowAnimation(false);
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    } else {
      IBBReInvestmentSaveCustom(uploadFileList);
    }
  }
  //Dragdrop ends

  function IBBReInvestmentSaveCustom(uploadedFile: any) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbreinvestmentid = formData.IBBReInvestmentID;
    object.ibbprogramid = filterData.ProgramID;
    object.quarterid = filterData.QuarterID;
    object.ibbdepartmentid = formData.IBBDepartmentID;
    object.ibbpaymentcriteriaid = formData.IBBPaymentCriteriaID;
    object.title = SanitizeHtml(formData.Title);
    object.description = SanitizeHtml(formData.Description);
    object.requestedamountinlc = formData.RequestedAmountInLC;
    object.requestedamountinusd = formData.RequestedAmountInUSD;
    object.requestedpaymentdate = formData.RequestedPaymentDate;
    object.requestedforibbscorecardids = formData.RequestedForIBBScorecardIDs;
    object.filesdata = uploadedFile;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL + "api/IBBReInvestment/IBBReInvestmentSaveCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;
          setCurrentView(1);
          setFormData({});
          IBBReInvestmentGetCompleteGridDataCustom();
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBReInvestmentDeleteRecordCustom(IBBReInvestmentID: number) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbreinvestmentid = IBBReInvestmentID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBReInvestment/IBBReInvestmentDeleteRecordCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          IBBReInvestmentGetCompleteGridDataCustom();
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function InputMaskOnChangeHandler(e: any) {
    let Amount = removeNonNumeric(e.Value);
    formData.RequestedAmountInUSD = Amount;
    setFormData((prevState: any) => ({
      ...prevState,
      RequestedAmountInUSD: Amount,
    }));
  }

  function InputMaskOnBlurHandler(e: any) {}

  function getCurrencyIDByIBBScorecardID() {
    var filtered = importerList.filter(
      (item: any) => item.PID == formData.IBBScorecardID
    );
    if (filtered.length > 0) {
      setFormData((prevState: any) => ({
        ...prevState,
        CurrencyID: filtered[0].CurrencyID,
      }));
    }
  }

  function assignAvailableAmount() {
    let availableAmountInUSD = 0;
    let remainingAmountInUSD = 0;

    if (totalData.AvailableFunds >= 0)
      availableAmountInUSD =
        Number(totalData.AvailableFunds) +
        Number(formData.RequestedAmountInUSDBK);

    remainingAmountInUSD =
      availableAmountInUSD - Number(formData.RequestedAmountInUSD);
    if (remainingAmountInUSD < 0) remainingAmountInUSD = 0;

    setFormData((prevState: any) => ({
      ...prevState,
      AvailableAmountInUSD: availableAmountInUSD,
      RemainingAmountInUSD: remainingAmountInUSD,
    }));
  }

  function updateSelectedPIDForParent(type: any, value: any) {
    if (type == 1) {
      formData.RequestedForIBBScorecardIDs = value;
      setFormData((prevState: any) => ({
        ...prevState,
        RequestedForIBBScorecardIDs: value,
      }));
    }
  }

  function rebindFiles(id: number) {
    let attachments = [] as any;
    if (gridData && gridData[3] && gridData[3].length > 0) {
      for (let i = 0; i < gridData[3].length; i++) {
        if (gridData[3][i].ObjectID == id) {
          attachments.push({
            ObjectID: gridData[3][i].ObjectID,
            Name: gridData[3][i].Name,
            FileURLDisplay: AppContext.GetFileIconToDisplay(
              gridData[3][i].FileURLRaw
            ),
            FileURL: gridData[3][i].FileURLRaw,
            AlreadyUploaded: true,
            S3Path: gridData[3][i].S3Path,
            Identifier: gridData[3][i].Identifier,
            Title: gridData[3][i].Title,
            Tags: gridData[3][i].Tags,
          });
        }
      }
    }
    setDragDropFeatures((prevState: any) => ({
      ...prevState,
      PTUploadedFiles: attachments,
    }));
  }

  const [reinvestmentsData, setReInvestmentsData] = useState<any>([]);
  const [exceptionsDocuments, setExceptionsDocuments] = useState<any>([]);

  //MM:: Approval related data
  const [requiredApprovalUser, setRequiredApprovalUser] = useState([]) as any;

  function IBBReInvestmentGetDataForApproval() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbprogramid = filterData.ProgramID;
    object.quarterid = filterData.QuarterID;
    object.statusid = -1;
    object.ibbreinvestmentid = formData.IBBReInvestmentID;
    object.ibbprogramstageid = 21;
    object.ibbprogramsectionid = 0;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBReInvestment/IBBReInvestmentGetDataForApproval",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;

          if (result.length > 2) {
            let exceptionsDataLocal = [];
            var filtered = result[0];
            if (filtered.length > 0)
              exceptionsDataLocal.push({
                SectionTypeName: "Re-Investment Requests",
                Data: filtered,
              });

            setReInvestmentsData(exceptionsDataLocal);
            setExceptionsDocuments(result[1]);
            setRequiredApprovalUser(result[2]);
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function triggerApprovalParent() {
    IBBReInvestmentGetDataForApproval();
  }

  function ConfirmationCallBack(obj: any) {
    if (obj.ID === 1) {
      if (obj.isConfirm === true) {
        IBBReInvestmentDeleteRecordCustom(obj.SelectedID);
      }
    }
    globalState.setConfirmationObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID: 0,
    });
  }

  return (
    <>
      {showAnimation && <LoadingAnimation />}
      <Confirmation
        ConfirmationObject={globalState.ConfirmationObject}
        ConfirmationCallBack={ConfirmationCallBack}
      />
      {currentView == 1 && (
        <div className="page--contents">
          <div className="page--breadcrumb">
            <a>Re-Investment requests</a>
          </div>
          <div className="page--data">
            <div className="flex-container">
              <div style={{ width: "33.33%" }}>
                <select
                  className="select-md"
                  value={filterData.ProgramID}
                  onChange={(e) => {
                    setFilterData((prevState: any) => ({
                      ...prevState,
                      ProgramID: Number(e.target.value),
                      QuarterID: 0,
                      IBBScorecardID: 0,
                    }));
                    globalState.setTopFilterData((prevState: any) => ({
                      ...prevState,
                      IBBProgramID: Number(e.target.value),
                      QuarterID: 0,
                    }));
                    IBBProgramGetProgramListForScorecard(
                      Number(e.target.value),
                      0,
                      0,
                      0
                    );
                  }}
                >
                  {programList &&
                    programList.map((Item: any, index: any) => (
                      <option value={Item.PID} key={"program" + Item.PID}>
                        {Item.Name}
                      </option>
                    ))}
                </select>

                <select
                  style={{ marginLeft: 5 }}
                  className="select-md"
                  value={filterData.QuarterID}
                  onChange={(e) => {
                    setFilterData((prevState: any) => ({
                      ...prevState,
                      QuarterID: Number(e.target.value),
                      IBBScorecardID: 0,
                    }));
                    globalState.setTopFilterData((prevState: any) => ({
                      ...prevState,
                      QuarterID: Number(e.target.value),
                    }));
                  }}
                >
                  <option value={0} key={"quarter" + 0}>
                    YTD
                  </option>
                  {quarterList &&
                    quarterList.map((Item: any, index: any) => (
                      <option value={Item.PID} key={"quarter" + Item.PID}>
                        {Item.Name}
                      </option>
                    ))}
                </select>
              </div>
              <span style={{ width: "33.33%" }}></span>

              <span></span>
            </div>
            <div className="flex-container">
              <div className="flex-items sm-re-earn">
                <div className="re-earn">
                  <span className="re-val1">
                    <span>Total Funds:</span>
                  </span>
                  <span className="re-val2">
                    $
                    {totalData.TotalFunds?.toLocaleString(undefined, {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    })}
                  </span>
                </div>
                <div className="re-earn">
                  <span className="re-val1">
                    <span>Used Funds:</span>
                  </span>
                  <span className="re-val2">
                    $
                    {totalData.Usedfunds?.toLocaleString(undefined, {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    })}
                  </span>
                </div>
                <div className="re-earn">
                  <span className="re-val1">
                    <span>Available Funds:</span>
                  </span>
                  <span className="re-val2">
                    $
                    {totalData.AvailableFunds?.toLocaleString(undefined, {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    })}
                  </span>
                </div>
              </div>
              {getAccessSettings(2, 30) > 1 && filterData.QuarterID > 0 && (
                <a
                  title="Add Release To Profit"
                  className="btn-primary btn-prf"
                  onClick={() => {
                    setFormData({
                      IBBProgramID: filterData.ProgramID,
                      QuarterID: filterData.QuarterID,
                      RequestedAmountInLC: 0,
                      RequestedAmountInUSD: 0,
                      RequestedAmountInUSDBK: 0,
                      RequestedForIBBScorecardIDs: "",
                      IBBReInvestmentID: 0,
                      IBBDepartmentID: 9,
                      IBBPaymentCriteriaID: 3,
                      Title: "Release To Profit",
                    });
                    setSelectedPIDs("");
                    setCurrentView(2);
                    setCanEdit(true);
                    setDragDropFeatures((prevState: any) => ({
                      ...prevState,
                      PTUploadedFiles: [],
                    }));
                  }}
                >
                  Release To Profit
                </a>
              )}
            </div>

            <div
              className="flex-title re-accord"
              onClick={() => setSecondAccord(!secondAccord)}
            >
              <a className="a-accord">
                <span>Requests</span>
                <img
                  src="/images/expand.svg"
                  className={secondAccord ? "rotate-180" : ""}
                  width="20px"
                  height="37px"
                />
              </a>
            </div>

            {secondAccord && (
              <div className="section-table">
                {getAccessSettings(2, 7) > 1 && filterData.QuarterID > 0 && (
                  <div className="flex-container">
                    <span></span>
                    <div className="flex-items">
                      <a
                        className="btn-link"
                        onClick={() => {
                          setFormData({
                            IBBProgramID: filterData.ProgramID,
                            QuarterID: filterData.QuarterID,
                            RequestedAmountInLC: 0,
                            RequestedAmountInUSD: 0,
                            RequestedAmountInUSDBK: 0,
                            RequestedForIBBScorecardIDs: "",
                            IBBReInvestmentID: 0,
                          });
                          setSelectedPIDs("");
                          setCurrentView(2);
                          setCanEdit(true);
                          setDragDropFeatures((prevState: any) => ({
                            ...prevState,
                            PTUploadedFiles: [],
                          }));
                        }}
                      >
                        Add Re-investment Request
                      </a>

                      <a
                        className="btn-primary "
                        title="Export Requests"
                        onClick={() =>
                          DownloadClientsDataInExcel(
                            "reinverstmentrequests",
                            "RE-INVESTMENT REQUESTS  "
                          )
                        }
                      >
                        <img src="images/export.svg" width="18" height="18" />
                      </a>
                    </div>
                  </div>
                )}
                <table
                  className="part-head trend-table fixed-table"
                  id="reinverstmentrequests"
                >
                  <thead>
                    <tr>
                      <th>Project</th>
                      <th>Amount</th>
                      <th>Request For</th>
                      <th>Requested By</th>
                      <th>Status</th>
                      <th className="sm-col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {gridData[2] &&
                      gridData[2].map((item: any, index: any) => (
                        <React.Fragment key={"program" + index}>
                          <tr>
                            <td>{item.Title}</td>
                            <td className="text-right">
                              {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                item.CurrencyID
                              )}
                              {item.RequestedAmountInUSD?.toLocaleString(
                                undefined,
                                {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                }
                              )}
                            </td>

                            <td>{item.RequestFor}</td>
                            <td>{item.RequestedByName}</td>
                            <td
                              className={`
                              ${item.Status == 1 ? "sig-green" : ""}
                              ${item.Status == 2 ? "sig-red" : ""}
                          `}
                            >
                              {item.StatusName}
                            </td>

                            <td className="sm-col">
                              {getAccessSettings(2, 7) > 1 && (
                                <div
                                  className="width-100 text-center btn-sm-grid"
                                  style={{ justifyContent: "flex-start" }}
                                >
                                  <a
                                    className="btn-primary btn-grid"
                                    onClick={() => {
                                      let localItem = item;
                                      localItem.RequestedAmountInUSDBK =
                                        localItem.RequestedAmountInUSD;
                                      rebindFiles(localItem.IBBReInvestmentID);
                                      setCurrentView(3);
                                      setFormData(localItem);
                                      setSelectedPIDs(
                                        localItem.RequestedForIBBScorecardIDs
                                      );
                                    }}
                                    title={
                                      item.Status == 0
                                        ? "Edit "
                                        : "View Details"
                                    }
                                  >
                                    <img
                                      src="images/edit.svg"
                                      width={15}
                                      height={15}
                                    />
                                  </a>
                                  {(item.Status == 0 ||
                                    globalState.ManageAdmin ||
                                    getAccessSettings(2, 26) > 1) && (
                                    <>
                                      <a
                                        className="btn-primary btn-grid"
                                        onClick={() => {
                                          globalState.setConfirmationObject({
                                            ShowPopup: true,
                                            Heading: "Confirmation ",
                                            Message:
                                              "Are you sure you want to delete this record?",
                                            ID: 1,
                                            SelectedID: item.IBBReInvestmentID,
                                          });
                                        }}
                                        // onClick={() => {
                                        //   IBBReInvestmentDeleteRecordCustom(
                                        //     item.IBBReInvestmentID
                                        //   );
                                        // }}
                                        title="Delete"
                                      >
                                        <img
                                          src="images/delete.svg"
                                          width={15}
                                          height={15}
                                        />
                                      </a>
                                    </>
                                  )}
                                </div>
                              )}
                            </td>
                          </tr>
                        </React.Fragment>
                      ))}
                  </tbody>
                </table>
              </div>
            )}

            <div
              className="flex-title re-accord"
              onClick={() => setFirstAccord(!firstAccord)}
            >
              <a className="a-accord">
                <span>Source</span>
                <img
                  src="/images/expand.svg"
                  className={firstAccord ? "rotate-180" : ""}
                  width="20px"
                  height="37px"
                />
              </a>
            </div>

            {firstAccord && (
              <div className="section-table">
                <div className="flex-container">
                  <span></span>
                  <div className="flex-items">
                    <a
                      className="btn-primary "
                      title="Export Source"
                      onClick={() =>
                        DownloadClientsDataInExcel(
                          "tblreinvestmentsource",
                          "RE-INVESTMENT SOURCE  "
                        )
                      }
                    >
                      <img src="images/export.svg" width="18" height="18" />
                    </a>
                  </div>
                </div>

                <table
                  className="part-head trend-table fixed-table"
                  id="tblreinvestmentsource"
                >
                  <thead>
                    <tr>
                      <th>Importer</th>
                      <th>Amount</th>
                      {filterData.QuarterID > 0 && <th>Date</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {gridData[1] &&
                      gridData[1].map((item: any, index: any) => (
                        <React.Fragment key={"program" + index}>
                          <tr>
                            <td>{item.DealerName}</td>
                            <td className="text-right">
                              {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                item.CurrencyID
                              )}
                              {item.AmountInUSD?.toLocaleString(undefined, {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                              })}
                            </td>
                            {filterData.QuarterID > 0 && (
                              <td className="text-right">
                                {item.DataDate != undefined &&
                                  item.DataDate != "" && (
                                    <>
                                      {moment(item.DataDate).format(
                                        "DD/MM/YYYY"
                                      )}
                                    </>
                                  )}
                              </td>
                            )}
                          </tr>
                        </React.Fragment>
                      ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      )}

      {currentView > 1 && (
        <>
          <div className="page--contents">
            <div className="page--breadcrumb">
              {currentView == 2 && formData.IBBPaymentCriteriaID != 3 && (
                <a>Add Re-Investment Request</a>
              )}
              {currentView == 3 && formData.IBBPaymentCriteriaID != 3 && (
                <a>Edit Re-Investment Request</a>
              )}
              {currentView == 2 && formData.IBBPaymentCriteriaID == 3 && (
                <a>Add Release To Profit Request</a>
              )}
              {currentView == 3 && formData.IBBPaymentCriteriaID == 3 && (
                <a>Edit Release To Profit Request</a>
              )}
            </div>
            <div className="page--data">
              <div className="flex-container">
                <div className="flex-items">
                  <b>
                    {programList &&
                      programList.map((item: any, index: any) => (
                        <>
                          {item.PID == filterData.ProgramID && (
                            <span> {item.Name}</span>
                          )}
                        </>
                      ))}

                    {quarterList &&
                      quarterList.map((item: any, index: any) => (
                        <>
                          {item.PID == filterData.QuarterID && (
                            <span> - {item.Name}</span>
                          )}
                        </>
                      ))}
                  </b>
                </div>
              </div>
              <div className="p-form-inn">
                <div className="program-form re-in-form">
                  <div className="form-item">
                    <span>Title:</span>
                    <input
                      value={formData.Title}
                      onChange={(e) =>
                        setFormData((prevState: any) => ({
                          ...prevState,
                          Title: e.target.value,
                        }))
                      }
                      type="text"
                    />
                  </div>
                  <div className="form-item">
                    <span>Description:</span>
                    <textarea
                      value={formData.Description}
                      onChange={(e) =>
                        setFormData((prevState: any) => ({
                          ...prevState,
                          Description: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <div className="form-item">
                    <span>Requester:</span>
                    <input
                      value={globalState.LogInUserName}
                      type="text"
                      disabled
                    />
                  </div>
                  {formData.IBBPaymentCriteriaID != 3 && (
                    <>
                      <div className="form-item">
                        <span>Requesting Function:</span>
                        <select
                          className="select-sm"
                          value={formData.IBBDepartmentID}
                          onChange={(e) =>
                            setFormData((prevState: any) => ({
                              ...prevState,
                              IBBDepartmentID: Number(e.target.value),
                            }))
                          }
                        >
                          <option value={0} key={"importer" + 0}>
                            Please Select
                          </option>
                          {foreignKeysData[0] &&
                            foreignKeysData[0].map((Item: any, index: any) => (
                              <option
                                value={Item.PID}
                                key={"importer" + Item.PID}
                              >
                                {Item.Name}
                              </option>
                            ))}
                        </select>
                      </div>

                      <div className="form-item">
                        <span>Re-investment Request For:</span>
                        <MultiSelectionDropdownV3
                          listData={importerList}
                          selectAllName={"Multiple Markets"}
                          selectFewName={"Importers"}
                          updateSelectedPIDForParent={
                            updateSelectedPIDForParent
                          }
                          type={1}
                          selectedPID={selectedPIDs}
                        ></MultiSelectionDropdownV3>
                      </div>
                    </>
                  )}
                  <div className="form-item">
                    {formData.IBBPaymentCriteriaID != 3 && (
                      <span>Requested Re-investment Amount:</span>
                    )}
                    {formData.IBBPaymentCriteriaID == 3 && (
                      <span>Requested Release To Profit Amount:</span>
                    )}

                    <InputMask
                      Disabled={false}
                      Prefix={AppContext.GetCurrencyIconBasedOnCurrencyID(
                        formData.CurrencyID
                      )}
                      Suffix={""}
                      ToFixed={0}
                      ClassName=""
                      ColumnName="1"
                      Value={formData.RequestedAmountInUSD}
                      PID={1}
                      onChangeHandler={InputMaskOnChangeHandler}
                      onBlurHandler={InputMaskOnBlurHandler}
                    />
                  </div>

                  <div className="form-item">
                    {formData.IBBPaymentCriteriaID != 3 && (
                      <span>Available Re-investment Budget:</span>
                    )}
                    {formData.IBBPaymentCriteriaID == 3 && (
                      <span>Available Release To Profit Budget:</span>
                    )}

                    <InputMask
                      Disabled={true}
                      Prefix={AppContext.GetCurrencyIconBasedOnCurrencyID(
                        formData.CurrencyID
                      )}
                      Suffix={""}
                      ToFixed={0}
                      ClassName=""
                      ColumnName="1"
                      Value={formData.AvailableAmountInUSD}
                      PID={1}
                      onChangeHandler={InputMaskOnChangeHandler}
                      onBlurHandler={InputMaskOnBlurHandler}
                    />
                  </div>

                  <div className="form-item">
                    {formData.IBBPaymentCriteriaID != 3 && (
                      <span>Remaining Re-investment Budget:</span>
                    )}
                    {formData.IBBPaymentCriteriaID == 3 && (
                      <span>Remaining Release To Profit Budget:</span>
                    )}
                    <InputMask
                      Disabled={true}
                      Prefix={AppContext.GetCurrencyIconBasedOnCurrencyID(
                        formData.CurrencyID
                      )}
                      Suffix={""}
                      ToFixed={0}
                      ClassName=""
                      ColumnName="1"
                      Value={formData.RemainingAmountInUSD}
                      PID={1}
                      onChangeHandler={InputMaskOnChangeHandler}
                      onBlurHandler={InputMaskOnBlurHandler}
                    />
                  </div>
                  {formData.IBBPaymentCriteriaID != 3 && (
                    <div className="form-item">
                      <span>Payment Criteria for Requested Re-investment:</span>
                      <select
                        className="select-sm"
                        value={formData.IBBPaymentCriteriaID}
                        onChange={(e) =>
                          setFormData((prevState: any) => ({
                            ...prevState,
                            IBBPaymentCriteriaID: Number(e.target.value),
                          }))
                        }
                      >
                        <option value={0} key={"importer" + 0}>
                          Please Select
                        </option>
                        {foreignKeysData[1] &&
                          foreignKeysData[1].map((Item: any, index: any) => (
                            <option
                              value={Item.PID}
                              key={"importer" + Item.PID}
                            >
                              {Item.Name}
                            </option>
                          ))}
                      </select>
                    </div>
                  )}
                  <div className="form-item">
                    <span>Requested Payment Date:</span>
                    <input
                      className="input-field select-field"
                      type="date"
                      value={moment(formData.RequestedPaymentDate).format(
                        "YYYY-MM-DD"
                      )}
                      onChange={(e) =>
                        setFormData((prevState: any) => ({
                          ...prevState,
                          RequestedPaymentDate: e.target.value,
                        }))
                      }
                    />
                  </div>

                  <div className="form-item">
                    <span>Attachments:</span>
                    <div className="flex-items supp-doc inv-doc">
                      <div className="order-drag">
                        <DragDrop
                          ParentFeatures={dragDropFeatures}
                          DragDropCallback={handleDragDropCallback}
                          TriggerChild={triggerChild}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="help-btns">
                  {(formData.IBBReInvestmentID == undefined ||
                    formData.IBBReInvestmentID == 0 ||
                    (formData.IBBReInvestmentID > 0 &&
                      (formData.Status == 0 ||
                        globalState.ManageAdmin ||
                        getAccessSettings(2, 26) > 1))) && (
                    <a
                      className="btn-primary btn-grid btn-secs"
                      onClick={() =>
                        showPopUpForSaveFiles(
                          AppContext.FileUploadObjectTypeInvoiceFile,
                          formData.IBBReInvestmentID
                        )
                      }
                    >
                      Save
                    </a>
                  )}
                  <a
                    className="btn-primary btn-grid btn-secs"
                    onClick={() => {
                      setCurrentView(1);
                      setFormData({});
                    }}
                  >
                    Back to List View
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="page--data">
            <div className="section-table mb-10 exception-up">
              {reinvestmentsData &&
                reinvestmentsData.map((item: any, index: any) => (
                  <React.Fragment key={item.SectionTypeName}>
                    {item.Data &&
                      item.Data.map(
                        (itemReInvestment: any, indexException: any) => (
                          <React.Fragment
                            key={itemReInvestment.IBBReInvestmentID}
                          >
                            {itemReInvestment.IBBReInvestmentID ==
                              formData.IBBReInvestmentID && (
                              <div className="buis-case case-back plr-20">
                                <div className="excep-heading">
                                  <span>{itemReInvestment.Title}</span>
                                  <div className="flex-items">
                                    <span>{itemReInvestment.RequestFor}</span>
                                  </div>
                                </div>
                                <div className="exception-grid">
                                  <div className="exceptions-left">
                                    <div className="flex-items buis-head">
                                      <span>
                                        Amount:{" "}
                                        {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                          itemReInvestment.CurrencyID
                                        )}
                                        {itemReInvestment.RequestedAmountInUSD.toLocaleString(
                                          undefined,
                                          {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0,
                                          }
                                        )}
                                      </span>{" "}
                                      <span>
                                        Date:{" "}
                                        {moment(item.RequestedTimestamp).format(
                                          "DD/MM/YYYY"
                                        )}
                                      </span>
                                      {itemReInvestment.IBBPaymentCriteriaID !=
                                        3 && (
                                        <>
                                          <span>
                                            Function:{" "}
                                            {itemReInvestment.IBBDepartmentName}
                                          </span>{" "}
                                        </>
                                      )}
                                      <span>
                                        Payment Criteria:{" "}
                                        {
                                          itemReInvestment.IBBPaymentCriteriaName
                                        }
                                      </span>{" "}
                                      <span
                                        className={`
                               ${
                                 itemReInvestment.Status == 1 ? "sig-green" : ""
                               }
                               ${itemReInvestment.Status == 2 ? "sig-red" : ""}
                          `}
                                      >
                                        Status: {itemReInvestment.StatusName}
                                      </span>
                                    </div>
                                    <span>
                                      <b>Description:</b>
                                    </span>
                                    <span className="flex-items">
                                      {itemReInvestment.Description}
                                    </span>
                                    <div className="flex-items supp-doc">
                                      <span>Supporting Documents:</span>
                                      <>
                                        {exceptionsDocuments &&
                                          exceptionsDocuments.map(
                                            (
                                              ItemAttachment: any,
                                              indexAttachment: any
                                            ) => (
                                              <>
                                                {itemReInvestment.IBBReInvestmentID ==
                                                  ItemAttachment.ObjectID && (
                                                  <span
                                                    key={
                                                      ItemAttachment.ObjectID +
                                                      "" +
                                                      indexAttachment
                                                    }
                                                  >
                                                    <a
                                                      href={
                                                        ItemAttachment.FileURLRaw
                                                      }
                                                      target="blank"
                                                    >
                                                      <img
                                                        src="images/pdf.svg"
                                                        width="40px"
                                                        height="40px"
                                                      />
                                                    </a>
                                                  </span>
                                                )}
                                              </>
                                            )
                                          )}
                                      </>
                                    </div>
                                  </div>
                                  <div className="pg-importers appr-grid grid-signoff">
                                    <div className="appr-main">
                                      <div className="exceptions-right">
                                        <div className="req-by">
                                          <div className="req-left">
                                            <span className="req-title show-block">
                                              Requested by
                                            </span>
                                            <span className="req-val">
                                              {itemReInvestment.RequestedByName}
                                            </span>
                                          </div>
                                          <div className="req-right"></div>
                                        </div>
                                        <div className="excp-approval">
                                          <ApprovalsScreen
                                            approvalObjectType={29}
                                            IBBProgramID={filterData.ProgramID}
                                            QuarterID={filterData.QuarterID}
                                            IBBProgramSectionID={0}
                                            ApprovalTextType={1}
                                            approvalObjectID={
                                              itemReInvestment.IBBReInvestmentID
                                            }
                                            uploadObjectType={
                                              AppContext.FileUploadObjectTypeExceptionApprovalFile
                                            }
                                            requiredApprovalUser={
                                              requiredApprovalUser
                                            }
                                            triggerApprovalParent={
                                              triggerApprovalParent
                                            }
                                          ></ApprovalsScreen>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </React.Fragment>
                        )
                      )}
                  </React.Fragment>
                ))}
            </div>
          </div>
        </>
      )}
    </>
  );
}
